module.exports = __webpack_public_path__ + "img/icon_vip_class_upgrading.cf44840d.png";